import { render } from "./Double.vue?vue&type=template&id=1f8133ba&scoped=true&ts=true"
import script from "./Double.vue?vue&type=script&lang=ts"
export * from "./Double.vue?vue&type=script&lang=ts"

import "./Double.vue?vue&type=style&index=0&id=1f8133ba&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8133ba"]])

export default __exports__